import { cobraApi } from "../framework";
import { cobraConstants } from "./cobra-constants";

const state = {
  ready: false,
  participantId: null,
  electionEvents: []
}

const getters = {
  events: (state) => {
    return (state.electionEvents.length > 0) ? state.electionEvents : [];
  },
  hasActiveElectionEvent: (state) => {
    return (state.electionEvents.length > 0) ? state.electionEvents.some(ee => ee.elections.some(e => e.status !== cobraConstants.ELECTION_STATUSES.Terminated)) : false;
  },
  getEvent: (state) => (id) => {
    return state.electionEvents.find(x => id == x.electionEventId) || null;
  }
}

const actions = {
  async loadEvents(context, data) {
    let events = await cobraApi.GetElectionEvents(data.participantId);
    events = events.sort(function(a,b){ return b.eventDate.localeCompare(a.eventDate); });

    for (const i in events) {
      events[i].displayName = events[i].type === cobraConstants.ELECTION_EVENT_TYPES.LifeEvent ? events[i].lifeEventTypeName : 'Open Enrollment';

      var eventText = await cobraApi.get(`/participant/${data.participantId}/election-event/${events[i].electionEventId}/text`);
      if (!eventText) continue;

      let dollarPattern = /\$[\d,\.]+/g;
      events[i].invoiceText = eventText.invoiceText.replaceAll(dollarPattern,
        `<a href="#" title="Open Invoices for this Election Event" class="dynamic-link" election-event-id="${events[i].electionEventId}">$&</a>`
      );
      events[i].headerText = eventText.headerText;
      events[i].statusName = eventText.statusName;
      events[i].statusText = eventText.statusText;

      for (var j in events[i].elections) {
        var electionText = eventText.electionTexts.find(e => e.electionId === events[i].elections[j].electionId);
        if (!electionText) continue;

        events[i].elections[j].coverageText = electionText.coverageText;
        events[i].elections[j].statusText = electionText.statusText;
        events[i].elections[j].dependentText = electionText.dependentText;
        events[i].elections[j].statusName = electionText.statusName;
      }
    }

    context.commit('setData', { electionEvents: events });
  },
}

const mutations = {
  setData(state, data) {
    utils.copyCommonProperties(data, state);
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/cobra/x-cobra-election-events.js